// extracted by mini-css-extract-plugin
export var container = "Container-module--container--dfb2f";
export var flex = "Container-module--flex--9a7e8";
export var fluid = "Container-module--fluid--aa594";